/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedSelector } from '@hook/common/useStore';
import ToastTemplate from '@component/iyagigo/toast/toast-template';
import AuthenticExpressionToast from '@component/iyagigo/toast/page-toast/authentic-expression-toast';
import MiniStoryToast from '@component/iyagigo/toast/page-toast/mini-story-toast';
import { isAuthenticExpressionToastDataType, isMiniStoryToastDataType } from '@datatype/iyagigo/type';

const PageToast = () => {
  const pageToastData = useTypedSelector((state) => state.rootReducer?.modalReducer?.pageToastData) || null;

  return (
    <ToastTemplate>
      {isAuthenticExpressionToastDataType(pageToastData) && <AuthenticExpressionToast data={pageToastData.data} />}
      {isMiniStoryToastDataType(pageToastData) && <MiniStoryToast data={pageToastData.data} />}
    </ToastTemplate>
  );
};

export default PageToast;
